import * as React from "react"

import { Action } from "@tenforce/toolbox-button-push-react"

import { formatString } from "../../../util/Strings"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { Labels } from "../../../util/Translations"
import { Paging } from "../../../models"

interface Props {
    pagingInfo: Paging
    loadMore: () => void
}

export const LoadMoreCard = ({
    pagingInfo: { currentPage, totalNumberOfItems, pageSize },
    loadMore,
}: Props): JSX.Element => {
    const { LoadNMoreOf } = Labels

    const nextPageExists = totalNumberOfItems > currentPage * pageSize

    if (!nextPageExists) {
        return <></>
    }

    const itemsLeftToLoad = totalNumberOfItems - currentPage * pageSize
    const nextLoadMoreNumber =
        itemsLeftToLoad >= pageSize ? pageSize : itemsLeftToLoad
    const loadMoreLabel = formatString(
        LoadNMoreOf,
        nextLoadMoreNumber,
        totalNumberOfItems,
    )

    return (
        <article className="tw-w-full md:tw-w-1/2 lg:tw-w-1/4 tw-p-2">
            <Action
                extraClasses="NewUI-card tw-w-full theme-note bg-cloud"
                onClick={(): void => loadMore()}
                data-ft-load-more
            >
                <div className="NewUI-card__block tw-w-full">
                    {Symbols.Cards}&nbsp;{loadMoreLabel}
                </div>
            </Action>
        </article>
    )
}

export default LoadMoreCard
